var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"placeholder":_vm.customPlaceholder,"options":_vm.formOptions,"label":"name","trackBy":"id","loading":_vm.loading},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }